import axios from "axios";

// const api = axios.create({
//   baseURL: "http://localhost:5000/api"
// });

const api = axios.create({
  baseURL: "https://api.pos.croplyra.in/api", // ✅ LIVE BACKEND
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const isLoginPage = window.location.pathname === "/login";

    if (status === 401 && !isLoginPage) {
      console.warn("⚠️ Session expired. Redirecting to login.");

      localStorage.removeItem("token");

      // ⛔ prevent infinite reload loop
      setTimeout(() => {
        window.location.href = "/login";
      }, 100);
    }

    return Promise.reject(err);
  }
);


export default api;

// import axios from "axios";

// const api = axios.create({
//   baseURL: "https://api.pos.croplyra.in/api", // ✅ LIVE BACKEND
//   headers: {
//     "Content-Type": "application/json"
//   }
// });

// // Attach JWT token automatically
// api.interceptors.request.use(config => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// export default api;
